import T, { t } from '../../../../../../../../../common/components/T';
import { A } from '../../../../../../../../../hybrid/wrappers';
import { getData } from '../../../../../../../../../common/utils/router';
const Decimal = require('decimal.js');

export const getFormattedOptionPaymentSys = (el, settings) => {
    return el
        ? {
              ...el,
              value: el?.id,
              label: settings?.currency_format == 0 || settings?.currency_format == 1 ? el.symbol : el.code
          }
        : {};
};

export const getConvertedValue_ = async (from_finance_currency, to_finance_currency, amount, lang, userToken) => {
    const from_finance_currency_ = `from_finance_currency=${from_finance_currency}`;
    const to_finance_currency_ = `to_finance_currency=${to_finance_currency}`;
    const amount_ = `amount=${amount}`;

    const convertedData = await getData(
        `/api/v1/user/finance/convert-amount?${from_finance_currency_}&${to_finance_currency_}&${amount_}`,
        userToken,
        lang
    );
    return convertedData;
};

export function validationFloatNumbers(input) {
    let temp = input.replace(/[^0-9.]/g, '');
    let dotIndex = temp.indexOf('.');
    if (dotIndex !== -1) {
        temp = temp.substring(0, dotIndex + 1) + temp.substring(dotIndex + 1).replace(/\./g, '');
    }
    if (dotIndex === -1 && temp?.length > 1 && temp[0] === '0') {
        temp = temp.replace('0', '0.');
    }

    return temp;
}

export function validationPartSumNumbers(input, maxNumber) {
    const floatFormatted = validationFloatNumbers(input);
    if (isNaN(floatFormatted) && !floatFormatted) {
        return floatFormatted;
    }
    if (Number(floatFormatted) > Number(new Decimal(maxNumber).minus(0.1).toString())) {
        const result = new Decimal(maxNumber).minus(0.1);
        return result.toString();
    }

    return floatFormatted;
}

export const getTitle = (translation) => {
    const Link1 = (
        <A className={'activeLink'} href={`/page/agreement`}>
            {t('storeAccessPolitic1', 'Пользовательского соглашения', '/store', translation)}
        </A>
    );
    const Link2 = (
        <A className={'activeLink'} href={`/page/privacy_policy`}>
            {t('storeAccessPolitic2', 'Политика конфиденциальности', '/store', translation)}
        </A>
    );
    return (
        <div>
            <T
                textName='storeAccessPolitic'
                vars={{
                    link1: Link1,
                    link2: Link2
                }}
                defaultStr='Я ознакомился и принимаю условия ${link1} и ${link2}, и даю свое согласие на обработку персональных данных'
                page='/store'
            />
        </div>
    );
};
